<div class="progress">
  <div class="progress-bar">
    <div class="progress-inner" [style.width.%]="currentLevel == maxLevel ? 100 : vipProgress"></div>
  </div>
  <div class="progress-info" [class.is-left-menu]="isLeftMenu">
    @if (!isLeftMenu) {
      @if (currentLevel !== null && currentLevel < maxLevel) {
        <p>{{ 'level' | translate }} {{ currentLevel + 1 }}</p>
      } @else {
        <p>{{ 'level' | translate }} {{ maxLevel }}</p>
      }
    }

    @if (currentLevel == maxLevel) {
      <p>{{ 'you_have_reached_max_level' | translate }}</p>
    } @else {
      <p>{{ 'n_to_level_up' | translate: nextLevelPoint }}</p>
    }

    @if (!isLeftMenu) {
      <p>
        @if (currentLevel !== null && currentLevel < maxLevel) {
          {{ 'level' | translate }} {{ currentLevel + 2 }}
        } @else {
          {{ 'level' | translate }} {{ maxLevel + 1 }}
        }
      </p>
    }
  </div>
</div>
